(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["puiu-countdown"] && !Shopify.designMode) return;
  try {
    
class PuiuCountdown extends HTMLElement {
  connectedCallback() {
    const raw = (this.dataset.end || '').trim();
    if (!raw) return;
    const iso = raw.replace(' ', 'T');
    this.target = new Date(iso).getTime();
    if (isNaN(this.target)) return;

    this.els = {
      d: this.querySelector('[data-days]'),
      h: this.querySelector('[data-hours]'),
      m: this.querySelector('[data-minutes]'),
      s: this.querySelector('[data-seconds]'),
    };
    this.expired = this.querySelector('.puiu-countdown__expired');
    this.clock = this.querySelector('.puiu-countdown__clock');
    this.hideExpired = this.dataset.hideExpired === 'true';

    this.tick();
    this.timer = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); }

  pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

  tick() {
    const diff = this.target - Date.now();
    if (diff <= 0) {
      if (this.timer) window.clearInterval(this.timer);
      this.set(0, 0, 0, 0);
      if (this.hideExpired && !this.expired) { this.hidden = true; return; }
      if (this.clock) this.clock.hidden = true;
      const form = this.querySelector('.puiu-countdown__form');
      if (form) form.hidden = true;
      if (this.expired) this.expired.hidden = false;
      return;
    }
    const sec = Math.floor(diff / 1000);
    this.set(Math.floor(sec / 86400), Math.floor((sec % 86400) / 3600), Math.floor((sec % 3600) / 60), sec % 60);
  }

  set(d, h, m, s) {
    if (this.els.d) this.els.d.textContent = this.pad(d);
    if (this.els.h) this.els.h.textContent = this.pad(h);
    if (this.els.m) this.els.m.textContent = this.pad(m);
    if (this.els.s) this.els.s.textContent = this.pad(s);
  }
}
if (!customElements.get('puiu-countdown')) customElements.define('puiu-countdown', PuiuCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puiu-faq"] && !Shopify.designMode) return;
  try {
    
class PuiuFaq extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-single')) return;
    this.rows = Array.from(this.querySelectorAll('.puiu-faq__row'));
    this.rows.forEach((row) => {
      row.addEventListener('toggle', () => {
        if (!row.open) return;
        this.rows.forEach((other) => { if (other !== row) other.open = false; });
      });
    });
  }
}
if (!customElements.get('puiu-faq')) customElements.define('puiu-faq', PuiuFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puiu-hero"] && !Shopify.designMode) return;
  try {
    
class PuiuHero extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.puiu-hero__slides');
    this.slides = Array.from(this.querySelectorAll('.puiu-hero__slide'));
    if (this.slides.length < 2) return;
    this.isSlideMode = this.classList.contains('puiu-hero--transition-slide');
    this.filets = Array.from(this.querySelectorAll('.puiu-hero__filet-btn'));
    this.dots = Array.from(this.querySelectorAll('.puiu-hero__dot'));
    this.arrows = Array.from(this.querySelectorAll('.puiu-hero__arrow'));
    this.index = 0;
    this.count = this.slides.length;
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const goto = (n) => this.go(n);
    this.filets.forEach((btn) => btn.addEventListener('click', () => goto(parseInt(btn.dataset.goto, 10))));
    this.dots.forEach((btn) => btn.addEventListener('click', () => goto(parseInt(btn.dataset.goto, 10))));
    this.arrows.forEach((btn) => btn.addEventListener('click', () => goto(this.index + parseInt(btn.dataset.dir, 10))));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goto(this.index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goto(this.index + 1); }
    });

    let x0 = null;
    const vp = this.querySelector('.puiu-hero__viewport');
    vp.addEventListener('touchstart', (e) => { x0 = e.changedTouches[0].clientX; }, { passive: true });
    vp.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) goto(this.index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    const ap = parseInt(this.dataset.autoplay, 10);
    if (ap && !this.reduce) {
      this.delay = ap * 1000;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
      this.start();
    }

    this.addEventListener('shopify:block:select', (e) => {
      const li = e.target.closest ? e.target.closest('.puiu-hero__slide') : null;
      if (li) goto(this.slides.indexOf(li));
      this.stop();
    });
    this.addEventListener('shopify:block:deselect', () => this.start());
  }

  disconnectedCallback() { this.stop(); }

  start() { this.stop(); if (this.delay) this.timer = window.setInterval(() => this.go(this.index + 1), this.delay); }
  stop() { if (this.timer) { window.clearInterval(this.timer); this.timer = null; } }

  go(n) {
    n = ((n % this.count) + this.count) % this.count;
    if (n === this.index) return;
    this.index = n;
    if (this.isSlideMode) { this.track.style.transform = 'translateX(' + (-100 * n) + '%)'; }
    this.slides.forEach((el, i) => {
      const on = i === n;
      el.classList.toggle('is-active', on);
      if (on) { el.removeAttribute('aria-hidden'); } else { el.setAttribute('aria-hidden', 'true'); }
    });
    const sync = (list) => list.forEach((el, i) => {
      const on = i === n;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    sync(this.filets);
    sync(this.dots);
  }
}
if (!customElements.get('puiu-hero')) customElements.define('puiu-hero', PuiuHero);

  } catch(e) { console.error(e); }
})();
})();
